import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Navbar from './components/navigation/navbar/navbar';
import Footer from './components/footer/footer';
import { loginSuccess } from './redux/actions/authActions';
import { encryptStorage } from './utils/storage';
import Notify from './components/notify/notify.component';
import AuthPopups from './components/authpopups/AuthPopups.component';
import AppRoutes from './App.routes';
import GetstreamVideoComp from './components/getstream/Getstream.component';
import useTrackAppError from './hooks/useTrackAppError';
import './App.css';


function App() {
	const location = useLocation();
	useTrackAppError();
	const [path, setPath] = useState('');

	useEffect(() => {
		const user = encryptStorage.getItem('user-info');
		if (user) loginSuccess(user);
	}, []);

	useEffect(() => {
		setPath(location.pathname.includes('/admin') ? 'admin' : 'user');
	}, [location]);

	return (
		<div className='App'>
			<div className={`${path === 'admin' && 'flex-box'}`}>
				<Navbar />
				<Notify />
				<AppRoutes />
				<AuthPopups />
				<GetstreamVideoComp />
			</div>
			<Footer />
		</div>
	);
}

export default App;
